import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import PostFilter from './components/PostFilter';
import PartnersCarousel from './components/PartnersCarousel';
import RotatingGradientModule from './components/RotatingGradientModule';
import Header from './components/Header';
import HomeHero from './components/HomeHero';
import Statistics from './components/Statistics';
import Footer from './components/Footer';
import FooterTagline from './components/FooterTagline';
import Spa from './barba/Spa';
import ResponsiveVideo from './components/ResponsiveVideo';
import ScrollPageToButton from './components/ScrollPageToButton';
import AboutDrive from './components/AboutDrive';
import LanguageSwitcher from './components/LanguageSwitcher';
import ScrollToLinks from './components/ScrollToLinks';

import { install } from 'resize-observer';
import Map from './components/Map';
import DownloadForm from './components/DownloadForm';
import Testimonials from './components/Testimonials';
import CoreValues from './components/CoreValues';
import Events from './components/Events';
import VideoPlayer from './components/VideoPlayer';
import Media from './components/Media';
import Gallery from './components/Gallery';
import Countdown from './components/Countdown';
require('a11y_accordions');

if (!window.ResizeObserver) {
	install();
}

export class Milence {
	constructor() {
		// Promises waarop gewacht  wordt. Standaard wordt er gewacht op het 'DOMContentLoaded' event
		Promise.all([Milence.domReady()]).then(() => this.init());
	}

	init() {
		this.setVw();
		this.setVh();
		this.resizeObserver = new ResizeObserver((entries) => {
			this.setVw();
			this.setVh();
		});
		this.resizeObserver.observe(document.documentElement);

		document.addEventListener('bless', (e) => {
			Header.init(e);
			Footer.init(e);
			PartnersCarousel.init(e);
			FooterTagline.init(e);
			// HomeHero.init(e);
			Statistics.init(e);
			PostFilter.init(e);
			RotatingGradientModule.init(e);
			ResponsiveVideo.init(e);
			ScrollPageToButton.init(e);
			// AboutDrive.init(e);
			LanguageSwitcher.init(e);
			Map.init(e);
			DownloadForm.init(e);
			Testimonials.init(e);
			CoreValues.init(e);
			Events.init(e);
			VideoPlayer.init(e);
			ARIAaccordion.init();
			Media.init(e);
			Gallery.init(e);
			Countdown.init(e);

			e.detail.element.querySelectorAll('[data-header-type]').forEach((el) => {
				e.detail.element.classList.add('header-type-' + el.dataset.headerType);
			});
		});

		new ScrollToLinks();
		new Spa();

		jQuery(document).on('submit', 'form[data-formid]', function (evt) {
			const el = evt.target;
			if (!el.querySelector('[name="version_hash"]')) {
				const hiddenInput = `<input
					type="hidden"
					name="version_hash"
					value="${window.gform_theme_config?.common?.form?.honeypot?.version_hash}"
				/>`;
				el.insertAdjacentHTML('beforeend', hiddenInput);
			}
		});
	}

	setVw() {
		let vw = document.documentElement.clientWidth / 100;
		document.documentElement.style.setProperty('--vw', `${vw}px`);
	}
	setVh() {
		let vh = window.innerHeight / 100;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
		let vho = window.outerHeight / 100;
		document.documentElement.style.setProperty('--vho', `${vho}px`);
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Milence();
